import React, { useState, useEffect } from 'react';
import Logo from '../components/Logo';

interface AdminLoginProps {
  onAuth: (success: boolean) => void;
  onCancel: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onAuth, onCancel }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Pequeno delay para animação de entrada
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'admin123') {
      onAuth(true);
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center px-4 transition-all duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-brand-night/60 backdrop-blur-md"
        onClick={onCancel}
      ></div>

      {/* Modal Card */}
      <div className={`relative max-w-md w-full bg-white rounded-[40px] shadow-2xl p-10 border border-brand-sand transition-all duration-500 transform ${isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-8'}`}>

        {/* Close Button */}
        <button
          onClick={onCancel}
          className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-400 transition-colors"
        >
          ✕
        </button>

        <div className="text-center mb-8">
          <Logo className="w-16 h-16 rounded-2xl mx-auto mb-6" />
          <h2 className="font-display text-3xl font-semibold uppercase text-brand-dark mb-2">Painel de Gestão</h2>
          <p className="text-brand-stone text-sm">Digite a senha administrativa para acessar os dados do congresso.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-black text-brand-stone uppercase tracking-widest ml-1">Senha de Acesso</label>
            <div className="relative">
              <input
                autoFocus
                type="password"
                className={`w-full px-6 py-4 rounded-2xl bg-brand-sand/60 border outline-none transition-all ${error ? 'border-red-500 bg-red-50' : 'focus:bg-white focus:border-brand-amber border-transparent'}`}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 text-xl opacity-20">
                🔒
              </div>
            </div>
            {error && (
              <p className="text-red-500 text-[10px] font-bold uppercase tracking-wider mt-2 ml-1 animate-pulse">
                ⚠️ Senha Incorreta
              </p>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-brand-dark text-white py-5 rounded-2xl font-bold text-lg hover:bg-brand-night transition-all shadow-xl active:scale-95"
          >
            Acessar Painel
          </button>

          <p className="text-center text-[10px] text-brand-stone font-medium">
            Acesso exclusivo para organizadores IPCC.
          </p>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
